export default __webpack_public_path__ + "static/media/lynnStartMb.fc4c8528.png";